import { Users, DollarSign, CreditCard, Settings, Shield, FileText, Layers, Search, PlusCircle, PenTool, UserMinus, Box, Tool, Calculator, Lock, Banknote, Wallet, PiggyBank, Vote, Gift, ChartBar, Landmark, Phone, Building2, ShieldCheck, ArrowRightLeft } from 'lucide-react';

export const modules = [
  {
    title: 'Socios',
    description: 'Gestión de asociados, admisiones y bajas',
    icon: Users,
    href: '/socios',
    color: 'text-green-600',
    activeColor: 'bg-green-50 text-green-700',
    permission: 'socios.read',
    subItems: [
      { title: 'Buscar', href: '/socios', icon: Search, permission: 'socios.read' },
      { title: 'Nuevo Socio', href: '/socios/nuevo', icon: PlusCircle, permission: 'socios.create' },
      { title: 'Aprobar', href: '/socios/aprobacion', icon: PenTool, permission: 'socios.update' },
      { title: 'Dar de Baja', href: '/socios/baja', icon: UserMinus, permission: 'socios.delete' }
    ]
  },
  {
    title: 'Caja',
    description: 'Movimientos de caja y reportes diarios',
    icon: DollarSign,
    href: '/caja',
    color: 'text-blue-600',
    activeColor: 'bg-blue-50 text-blue-700',
    permission: 'caja.read',
    subItems: [
      { title: 'Operaciones', href: '/caja', icon: DollarSign, permission: 'caja.read' },
      { title: 'Arqueo', href: '/caja/arqueo', icon: Calculator, permission: 'caja.read' },
      { title: 'Cierre de Caja', href: '/caja/cierre', icon: Lock, permission: 'caja.read' },
      { title: 'Reporte Diario', href: '/caja/reporte', icon: FileText, permission: 'caja.read' }
    ]
  },
  {
    title: 'Préstamos',
    description: 'Solicitudes y pagos de créditos',
    icon: CreditCard,
    href: '/creditos',
    color: 'text-indigo-600',
    activeColor: 'bg-indigo-50 text-indigo-700',
    permission: 'creditos.read',
    subItems: [
      { title: 'Solicitud', href: '/creditos', icon: PlusCircle, permission: 'creditos.create' },
      { title: 'Solicitudes', href: '/creditos/solicitudes', icon: FileText, permission: 'creditos.approve' },
      { title: 'Historial', href: '/creditos/historial', icon: Layers, permission: 'creditos.read' },
      { title: 'Desembolsos', href: '/creditos/desembolsos', icon: Banknote, permission: 'creditos.read' },
      { title: 'Cartera', href: '/creditos/listado', icon: Users, permission: 'creditos.read' }
    ]
  },
  {
    title: 'Parametrización',
    description: 'Configuración de tablas maestras del sistema',
    icon: FileText,
    href: '/parametrizacion',
    color: 'text-orange-600',
    activeColor: 'bg-orange-50 text-orange-700',
    permission: 'config.read',
    subItems: [
      { title: 'Personas y Socios', href: '/parametrizacion/personas', icon: Users, permission: 'config.read' },
      { title: 'Prod. Financieros', href: '/parametrizacion/productos', icon: CreditCard, permission: 'config.read' },
      { title: 'Tesorería y Pagos', href: '/parametrizacion/tesoreria', icon: DollarSign, permission: 'config.read' },
      { title: 'Config Global', href: '/parametrizacion/global', icon: Settings, permission: 'config.read' }
    ]
  },
  {
    title: 'Seguridad',
    description: 'Gestión de usuarios y permisos',
    icon: Shield,
    href: '/seguridad',
    color: 'text-red-600',
    activeColor: 'bg-red-50 text-red-700',
    permission: 'admin',
    subItems: [
      { title: 'Usuarios', href: '/seguridad/usuarios', icon: Users, permission: 'usuario.read' },
      { title: 'Roles', href: '/seguridad/roles', icon: Lock, permission: 'rol.read' },
      { title: 'Permisos', href: '/seguridad/permisos', icon: Shield, permission: 'admin' }
    ]
  },
  {
    title: 'Automatización',
    description: 'Monitor de procesos y tareas programadas',
    icon: Layers,
    href: '/procesos',
    color: 'text-purple-600',
    activeColor: 'bg-purple-50 text-purple-700',
    permission: 'config.read',
    subItems: [
      { title: 'Monitor de Procesos', href: '/procesos', icon: Layers, permission: 'config.read' },
      { title: 'Log de Procesos', href: '/procesos/logs', icon: FileText, permission: 'config.read' }
    ]
  },
  {
    title: 'Finanzas',
    description: 'Gestión Financiera',
    icon: Wallet,
    href: '/finanzas',
    color: 'text-teal-600',
    activeColor: 'bg-teal-50 text-teal-700',
    permission: 'finanzas.read',
    subItems: [
      { title: 'General', href: '/finanzas', icon: Wallet, permission: 'finanzas.read' }
    ]
  },
  {
    title: 'Contabilidad',
    description: 'Gestión Contable Integral',
    icon: FileText,
    href: '/contabilidad',
    color: 'text-emerald-600',
    activeColor: 'bg-emerald-50 text-emerald-700',
    permission: 'finanzas.read',
    subItems: [
      { title: 'Libro Diario', href: '/contabilidad/diario', icon: FileText, permission: 'finanzas.read' },
      { title: 'Libro Mayor', href: '/contabilidad/mayor', icon: Layers, permission: 'finanzas.read' },
      { title: 'Sumas y Saldos', href: '/contabilidad/balance-saldos', icon: Calculator, permission: 'finanzas.read' },
      { title: 'Balance General', href: '/contabilidad/balance-general', icon: Landmark, permission: 'finanzas.read' },
      { title: 'Estado Resultados', href: '/contabilidad/estado-resultados', icon: ChartBar, permission: 'finanzas.read' },
      { title: 'Plan de Cuentas', href: '/contabilidad/plan-cuentas', icon: Search, permission: 'finanzas.read' }
    ]
  },
  {
    title: 'Ahorros',
    description: 'Cuentas de Ahorro',
    icon: PiggyBank,
    href: '/ahorros',
    color: 'text-green-600',
    activeColor: 'bg-green-50 text-green-700',
    permission: 'ahorros.read',
    subItems: [
      { title: 'Informe Ahorro', href: '/ahorros', icon: PiggyBank, permission: 'ahorros.read' }
    ]
  },
  {
    title: 'Votaciones',
    description: 'Procesos Electorales',
    icon: Vote,
    href: '/votaciones',
    color: 'text-blue-600',
    activeColor: 'bg-blue-50 text-blue-700',
    permission: 'votaciones.read',
    subItems: [
      { title: 'Activas', href: '/votaciones', icon: Vote, permission: 'votaciones.read' }
    ]
  },
  {
    title: 'Beneficios',
    description: 'Beneficios para Socios',
    icon: Gift,
    href: '/beneficios',
    color: 'text-pink-600',
    activeColor: 'bg-pink-50 text-pink-700',
    permission: 'beneficios.read',
    subItems: [
      { title: 'Disponibles', href: '/beneficios', icon: Gift, permission: 'beneficios.read' }
    ]
  },
  {
    title: 'Transparencia',
    description: 'Documentos Públicos',
    icon: FileText,
    href: '/transparencia',
    color: 'text-gray-600',
    activeColor: 'bg-gray-50 text-gray-700',
    permission: 'transparencia.read',
    subItems: [
      { title: 'Documentos', href: '/transparencia', icon: FileText, permission: 'transparencia.read' }
    ]
  },
  {
    title: 'Movimientos',
    description: 'Historial de transacciones y auditoría',
    icon: FileText,
    href: '/movimientos',
    color: 'text-slate-600',
    activeColor: 'bg-slate-50 text-slate-700',
    permission: 'movimientos.read',
    subItems: [
      { title: 'Historial', href: '/movimientos', icon: FileText, permission: 'movimientos.read' }
    ]
  },
  {
    title: 'Cobranzas',
    description: 'Gestión de mora y recuperación',
    icon: Phone,
    href: '/cobranzas',
    color: 'text-rose-600',
    activeColor: 'bg-rose-50 text-rose-700',
    permission: 'creditos.read',
    subItems: [
      { title: 'Gestión de Mora', href: '/cobranzas', icon: Phone, permission: 'creditos.read' }
    ]
  },
  {
    title: 'Informes',
    description: 'Estadísticas y reportes de gestión',
    icon: ChartBar,
    href: '/informes',
    color: 'text-indigo-600',
    activeColor: 'bg-indigo-50 text-indigo-700',
    permission: 'informes.read',
    subItems: [
      { title: 'Reporte Socios', href: '/informes/socios', icon: Users, permission: 'informes.read' },
      { title: 'Reporte Préstamos', href: '/informes/prestamos', icon: Banknote, permission: 'informes.read' }
    ]
  },
  {
    title: 'Tesorería',
    description: 'Gestión de bóveda y cierre de día',
    icon: Building2,
    href: '/tesoreria',
    color: 'text-slate-900',
    activeColor: 'bg-slate-100 text-slate-900',
    permission: 'tesoreria.read',
    subItems: [
      { title: 'Gestión de Tesorería', href: '/tesoreria/boveda', icon: Building2, permission: 'tesoreria.admin' },
      { title: 'Cierre de Día (EOD)', href: '/tesoreria/cierre-diario', icon: ShieldCheck, permission: 'tesoreria.cierre' }
    ]
  }
];
